import { DialogMaster } from "#core/components/dialog/Dialog"
import { useApiSend } from "#hooks/useApiSend"
import { STATUS_PLAN_ACTION } from "#performance-evaluation/constants"
import { evaluationActionPlanIdPut } from "#performance-evaluation/services/api"
import { Box, Typography } from "@mui/material"
import { useReloadRefresh } from "app/reload"
import { useState } from "react"

export default function ActionPlanEvidenceDelete({ open = true, setOpen, actionPlan }) {
	const { refresh } = useReloadRefresh()
	const [disabled, setDisabled] = useState(false)
	const success = () => {
		refresh()
		setOpen(false)
	}
	const end = () => {
		setDisabled(false)
	}
	const { fetch } = useApiSend(evaluationActionPlanIdPut, { success, end })
	const handleSubmit = () => {
		setDisabled(true)
		fetch(actionPlan.id, { status: STATUS_PLAN_ACTION.CREADO })
	}

	return (
		<DialogMaster
			{...{
				open,
				setOpen,
				maxWidth: "sm",
				handleSubmit,
				title: "Eliminar Evidencia",
				disabled,
			}}
		>
			<Box p={2} display="flex" flexDirection="column" gap={2}>
				<Typography variant="body1" align="center">
					¿Estás seguro de que deseas eliminar la evidencia del plan de acción de la
					competencia <strong>{actionPlan.competencia_name}</strong>?
				</Typography>
				<Typography variant="body2" align="center" color="text.secondary">
					Al eliminar la evidencia, el plan de acción volverá al estado "Creado". Esta
					acción no se puede deshacer
				</Typography>
			</Box>
		</DialogMaster>
	)
}
